

const productVariants = document.querySelectorAll('.product-single__meta .variant-wrapper .variant-input');
const productStickyVariants = document.querySelectorAll('.product-sticky-modal .variants .variant');
const productStickyModal = document.querySelector('.product-sticky-modal');

const productAtcButton = document.querySelector('.product-single__meta button[type="submit"]');

const productStickyATC = document.querySelector('.product-sticky-atc');
const productStickyAtcButton = document.querySelector('.product-sticky-atc .button');
const productStickyModalAtcButton = document.querySelector('.product-sticky-modal .button');

const overlay = document.querySelector('.overlay');

// FUNCTIONS

function enabledOverlay(){
    overlay.classList.add('enabled');
}
function disabledOverlay(){
    overlay.classList.remove('enabled');
}

function updateButtonState(variant){
    if(variant.classList.contains('disabled')){
        productStickyModalAtcButton.classList.add('disabled');
    }else{
        productStickyModalAtcButton.classList.remove('disabled');
    }
}

// DISPLAY STICKY BAR

function openStickyATC(){
    productStickyATC.classList.add('open');
}

function closeStickyATC(){
    productStickyATC.classList.remove('open');
}

document.addEventListener('scroll', () => {
    if(window.innerWidth < 749){
        if(window.scrollY > 900){
            openStickyATC();
        }else{
            closeStickyATC();
        }
    }else{
        if(window.scrollY > 500){
            openStickyATC();
        }else{
            closeStickyATC();
        }
    }
})

// SET VARIANT DISPONIBILITY

for(let i=0;i<productVariants.length;i++){
    const productVariantsLabel = productVariants[i].querySelector('label');
    if(productVariantsLabel.classList.contains('disabled')){
        for(let y=0;y<productStickyVariants.length;y++){
            if(productStickyVariants[y].dataset.value == productVariants[i].dataset.value){
                productStickyVariants[y].classList.add('disabled');
            }
        }
    }
}

// SET DEFAULT VARIANT

if(productVariants[0] != undefined){
    const firstProductVariant = productVariants[0].querySelector('label').click();
    productStickyVariants[0].classList.add('selected');
    updateButtonState(productStickyVariants[0]);
}

// VARIANTS SELECTION -------------------------------------------------------------------------

productVariants.forEach(variant => {
    variant.addEventListener('click', () => {
        for(let i=0;i<productStickyVariants.length;i++){
            if(productStickyVariants[i].dataset.value == variant.dataset.value){
                for(let y=0;y<productStickyVariants.length;y++){
                    productStickyVariants[y].classList.remove('selected');
                }
                productStickyVariants[i].classList.add('selected');
                updateButtonState(productStickyVariants[i]);
            }
        }
    })
})

productStickyVariants.forEach(variant => {
    variant.addEventListener('click', () => {
        for(let i=0;i<productVariants.length;i++){
            if(productVariants[i].dataset.value == variant.dataset.value){
                const productVariantsLabel = productVariants[i].querySelector('label');
                productVariantsLabel.click();
                for(let i=0;i<productStickyVariants.length;i++){
                    productStickyVariants[i].classList.remove('selected');
                }
                variant.classList.add('selected');
                updateButtonState(variant);
            }
        }
    })
})

// ATC BUTTON --------------------------------------------------------------------------------------

// SET DEFAULT

if(productVariants.length == 0){
    productStickyAtcButton.classList.add('direct-atc');
}else{
    productStickyAtcButton.classList.remove('direct-atc');
}

// INITIAL STICKY
productStickyAtcButton.addEventListener('click', () => {
    if(productVariants.length == 0){
        productAtcButton.click();
    }else{
        productStickyModal.classList.add('open');
        enabledOverlay();
    }
})

// MODAL STICKY
productStickyModalAtcButton.addEventListener('click', () => {

    if(productStickyModalAtcButton.classList.contains('disabled')){
    }else{
        productAtcButton.click();
        productStickyModal.classList.remove('open');
        disabledOverlay();
    }
})

/* OVERLRAY */

overlay.addEventListener('click', () =>{
    productStickyModal.classList.remove('open');
    disabledOverlay();
});